import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step4 } from '../../../../shared/models/component-messages/mapaAT/step4';
import { TypeCoord } from '../models/TypeCoord';

@Component({
  selector: 'app-type-coord',
  templateUrl: './type-coord.component.html'
})
export class TypeCoordComponent implements OnInit {

  @Input() uid = '';
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;
  @Input() coord : TypeCoord;
  @Input() rule = '';

  public step4 = new Step4();

  constructor() { }

  public ngOnInit() { }

  getUid() {
    return this.uid + '_SepSep_TypeCoord';
  }
}
